"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/NavTop.scss");

var _CardDeafult = _interopRequireDefault(require("./CardDeafult"));

var _Button = _interopRequireDefault(require("./Button"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _Link = _interopRequireDefault(require("./Link"));

var _iconsReact = require("@carbon/icons-react");

var _InputText = _interopRequireDefault(require("./InputText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavTop = function NavTop(_ref) {
  var category = _ref.category;

  var services = function services() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("header", {
      className: "navTop"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navTop-firstSection"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navTop-firstSection-name"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navTop-firstSection-logo"
    }), /*#__PURE__*/_react.default.createElement("h4", null, "Sample School")), /*#__PURE__*/_react.default.createElement("nav", {
      className: "navTop-navigation"
    }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "navTop-selected"
    }, "Overview")), /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("li", null, "Compare")), /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("li", null, "FAQ")), /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("li", null, "ScholaPromote")))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "navSecond"
    }, /*#__PURE__*/_react.default.createElement("h4", null, "Schola Premium Services"), /*#__PURE__*/_react.default.createElement(_Link.default, null, /*#__PURE__*/_react.default.createElement(_iconsReact.Download20, null), "Download Overview Booklet")));
  };

  var relationship = function relationship() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("header", {
      className: "navTop"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navTop-firstSection"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navTop-firstSection-name"
    }, /*#__PURE__*/_react.default.createElement("span", null, "Relationship Manager")), /*#__PURE__*/_react.default.createElement("nav", {
      className: "navTop-navigation"
    }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "navTop-selected"
    }, /*#__PURE__*/_react.default.createElement(_iconsReact.List24, null), "List")), /*#__PURE__*/_react.default.createElement("a", {
      href: "/"
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_iconsReact.Earth24, null), "Map"))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "navTop-secondSection"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      icon: /*#__PURE__*/_react.default.createElement(_iconsReact.Add24, null),
      size: "small"
    }, "Create"), /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      options: [{
        value: 'text',
        label: 'Sample School'
      }],
      size: "small"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "navSecondRelation"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navSecondRelation-childInput"
    }, /*#__PURE__*/_react.default.createElement(_InputText.default, {
      icon: /*#__PURE__*/_react.default.createElement(_iconsReact.Search24, null)
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      options: [{
        value: 'text',
        label: 'Any Stage'
      }],
      size: "small"
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      options: [{
        value: 'text',
        label: 'Any School year'
      }],
      size: "small"
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      options: [{
        value: 'text',
        label: 'Any grades'
      }],
      size: "small"
    }))));
  };

  return /*#__PURE__*/_react.default.createElement(_CardDeafult.default, null, category === 'services' && services(), category === 'relationship' && relationship());
};

_CardDeafult.default.propTypes = {
  category: _propTypes.default.oneOf(['services', 'relationship'])
};
NavTop.defaultProps = {
  category: 'services'
};
var _default = NavTop;
exports.default = _default;